import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../shared/base-service/base-api.service';

@Injectable()
export class CustomerPurgeService extends BaseApiService {

    constructor() {
        super();
    }

    public isPseudoCustomer(customerNumberId): Observable<any> {
        return this.get('Customer/IsPseudoCustomer/' + customerNumberId);
    }

    public purgeCustomer(customerNumberId): Observable<any> {
        return this.post('Customer/Purge/Queue/' + customerNumberId, null);
    }

    public deleteCustomerIdentification = (customerNumberId: number): Observable<any> => this.delete('Customer/Delete/SSN/' + customerNumberId);
}
